<mat-toolbar color="secondary">
  @if(windowMode !== 'large') { @if (user$ | async) {
  <button
    mat-icon-button
    aria-label="Example icon-button with menu icon"
    (click)="handleMenuBtnToggle()"
  >
    <mat-icon>menu</mat-icon>
  </button>
  } }
  <button type="button" mat-button color="secondary" [routerLink]="['/']">
    NAOSAKI
  </button>

  <aside class="is-left">
    <div class="flex align-center">
      <mat-icon>
        {{ toggleControl.value ? "light_mode" : "dark_mode" }}
      </mat-icon>
      <mat-slide-toggle
        [formControl]="toggleControl"
        class="mr-8"
      ></mat-slide-toggle>
    </div>
    <button mat-icon-button [matMenuTriggerFor]="lang">
      <mat-icon>language</mat-icon>
    </button>
  </aside>
</mat-toolbar>

<mat-menu #lang="matMenu">
  <button mat-menu-item (click)="switchUiLanguage('fr')">Francais</button>
  <button mat-menu-item (click)="switchUiLanguage('en')">English</button>
</mat-menu>
